import styled, { css, keyframes } from 'styled-components'
import { G, HEADER_BG } from '@/components/gold/theme'

/** 머니 새로고침 아이콘 회전 */
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

/* ---------- ver2(gold) 모바일 헤더 — m.gold8.bet 실측(390px 기준 높이 62px) ---------- */
export const GoldMHeader = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 62px;
  padding: 0 12px 0 14px;
  background: ${HEADER_BG};
  z-index: 30;
`

export const GoldMLogo = styled.a`
  display: flex;
  align-items: center;
  height: 44px;
  img { height: 100%; width: auto; max-width: 140px; object-fit: contain; }
`

export const GoldMLoginBtn = styled.button`
  height: 38px;
  padding: 0 22px;
  border: 2px solid ${G.mRed};
  border-radius: 19px;
  background: transparent;
  font-size: 15px;
  font-weight: 700;
  color: ${G.mRed};
`

export const GoldMAccount = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const GoldMUserIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  color: #9e0b1b;
  svg { width: 30px; height: 30px; fill: currentColor; color: inherit; }
`

export const GoldMInfo = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;
`

export const GoldMId = styled.span`
  font-size: 13px;
  color: #b5852a;
`

export const GoldMMoney = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #9e0b1b;
`

export const GoldMIconBtn = styled.button`
  display: flex;
  width: ${({ $big }) => ($big ? '22px' : '14px')};
  height: ${({ $big }) => ($big ? '22px' : '14px')};
  margin-left: ${({ $big }) => ($big ? '6px' : 0)};
  padding: 0;
  border: 0;
  background: none;
  color: #c4881c;
  svg { width: 100%; height: 100%; fill: currentColor; color: inherit; }
  ${({ $spinning }) => $spinning && css`
    svg { animation: ${spin} 0.6s linear infinite; }
  `}
`


/** LangSelector: 활성 국기 (버튼 안) */
export const LangFlagSm = styled.img`
  width: 22px;
  height: 16px;
  object-fit: cover;
`

/** LangSelector: 드롭다운 화살표 SVG */
export const LangCaret = styled.svg.attrs({ viewBox: '0 0 24 24' })`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`

/** LangSelector: 옵션 리스트 국기 */
export const LangFlagLg = styled.img`
  width: 30px;
  height: 22px;
  object-fit: cover;
  display: block;
`

export const Header = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--header-h-mobile);
  z-index: 100;
  display: flex;
  align-items: center;
`

export const InnerHeader = styled.div`
  position: relative;
  width: 95%;
  margin: 0 auto;
  display: flex;
  align-items: center;

  h1 img {
    max-width: 100%;
    width: 180px;
  }
`

export const TopSection = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;

  > button {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: var(--text-sm);
    &:hover { color: var(--current_text); }
  }
`

export const MTopSection = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`

export const InnerBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--text-sm);
`

export const MoneyTxt = styled.span`
  white-space: nowrap;
`

export const TxtYellow = styled.span`
  color: var(--lemon_text, #ffc107);
  font-weight: 600;
`

export const SquareBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #252a33;
  &:hover { background: #2f343e; }
`

export const LangSelectorWrap = styled.div`
  &.lang-selector-m .lang-btn {
    padding: 8px 10px !important;
    gap: 3px;
  }
  &.lang-selector-m .lang-text {
    font-size: var(--text-sm);
  }
  &.lang-selector-m .lang-item {
    display: block;
    text-align: center;
    padding: 5px 0;
    button { padding: 0; display: inline-block; }
  }
`
